import { IconNames, Text } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';

import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';

import { createConditionModalContainer } from '../../containers/condition';
import { INIT_NODE_LABEL } from '../constants';
import { ConditionModalPropsT } from '../modals';
import type { AutomationFlowExtraDataT } from '../types';

import { MatchingRuleT, MatchingStrategy } from './types';

export type AutomationNodeInitPayloadT = {
  matchNodeId: string;
  matchingStrategy: MatchingStrategy;
  rules: MatchingRuleT[];
};
export type AutomationNodeInitTypeT = AutomationNodeTypes.INIT;
export type AutomationNodeInitT = NodeT<
  AutomationNodeInitTypeT,
  AutomationNodeInitPayloadT
>;

const conditionalActionFormatter = (
  node: AutomationNodeInitT,
): Array<RegisterPortT> => [
  {
    id: uuid(),
    type: 'out',
    label: 'arrow',
    connection: node.payload.matchNodeId || uuid(),
  },
];

export const ConditionModalInit =
  createConditionModalContainer<AutomationNodeInitT>(
    AutomationNodeTypes.INIT,
    (node: ConditionModalPropsT<AutomationNodeInitT>['node']) => {
      if (node.nodeType === 'action') {
        return {
          matchNodeId: uuid(),
          matchingStrategy: MatchingStrategy.ALL,
          rules: [],
        } as AutomationNodeInitT['payload'];
      }

      return node.payload;
    },
  );

export class InitNode extends NodeTypeComponent<
  AutomationNodeInitT,
  AutomationFlowExtraDataT
>() {
  static icon: IconNames = 'merge';
  static label = INIT_NODE_LABEL;
  static translatePayload = formatPortsHelper(
    conditionalActionFormatter,
    () => [],
  );
  static ActionModal = ConditionModalInit;
  static updateConnection = (
    node: AutomationNodeInitT,
    _port: InternalPortT,
    newConnection: string,
  ): AutomationNodeInitT => {
    const payload = { ...node.payload };
    payload.matchNodeId = newConnection;
    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    const {
      node: {
        payload: { rules },
      },
    } = this.props;

    return (
      <FlowNode
        color={InitNode.color}
        icon={InitNode.icon}
        label={InitNode.label}
        text={
          <Text.Paragraph clamp={1} variant="1">
            {rules.length} {rules.length === 1 ? 'rule' : 'rules'}
          </Text.Paragraph>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
